import React from 'react';
import { Footer } from '../components/Footer';
import { Button } from '../components/Button';
import { ArrowRight, CheckCircle, Sparkles, Users, Brain } from 'lucide-react';
export const PilotClosed = () => {
  return <div className="flex flex-col min-h-screen bg-white" data-id="element-663" data-mp="30wj3ugjpcia8">
      <main className="relative flex-grow overflow-hidden" data-id="element-664" data-mp="2vwdbey5lyrr3">
        {/* Background pattern */}
        <div className="absolute inset-0 bg-grid-gray-900/[0.02] -z-10" data-id="element-665" data-mp="3tk5jwoa49fdz" />

        {/* Background gradient blobs - Preserved and refined */}
        <div className="absolute -left-[300px] top-[10%] w-[1400px] h-[1400px] bg-gradient-to-tr from-cyan-500/10 via-primary-300/5 to-cyan-200/10 rounded-[50%_50%_45%_55%] blur-3xl -z-10" data-id="element-666" data-mp="3om3rhcqsw3pu" />
        <div className="absolute top-0 right-1/3 w-[900px] h-[900px] bg-gradient-to-br from-cyan-400/10 via-teal-400/5 to-blue-400/10 rounded-[60%_40%_55%_45%] blur-3xl -z-10" data-id="element-667" data-mp="3ew0yvdnlcrs1" />
        <div className="absolute top-[30%] -left-[200px] w-[800px] h-[800px] bg-gradient-to-tr from-purple-400/10 via-violet-400/5 to-fuchsia-400/10 rounded-[40%_60%_45%_55%] blur-3xl -z-10 animate-float" style={{
        animationDelay: '2s'
      }} data-id="element-668" data-mp="besi6x4lnxyw" />
        <div className="absolute top-[60%] right-0 w-[750px] h-[750px] bg-gradient-to-bl from-amber-400/10 via-orange-400/5 to-red-400/10 rounded-[55%_45%_60%_40%] blur-3xl -z-10 animate-float" style={{
        animationDelay: '1.5s'
      }} data-id="element-669" data-mp="7j1xow3zle8y" />

        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-24 relative z-10" data-id="element-670" data-mp="3fzwp9ffc3c7q">
          {/* Hero Section */}
          <div className="text-center mb-16 md:mb-20" data-id="element-671" data-mp="3kzstnfry15nt">
            <div className="inline-flex items-center justify-center px-4 py-1.5 mb-6 rounded-full bg-cyan-50 border border-cyan-100 text-cyan-700 text-sm font-medium" data-id="element-672" data-mp="36yykgux2n0o3">
              <Sparkles className="w-4 h-4 mr-2" data-id="element-673" data-mp="3bybimbte7u5z" />
              New Chapter
            </div>
            <h1 className="text-4xl md:text-6xl font-serif font-normal text-cyan-900 mb-6 tracking-tight" data-id="element-674" data-mp="1584z1r0ejp86">
              The pilot phase is complete
            </h1>
            <p className="text-xl md:text-2xl text-gray-600 max-w-2xl mx-auto font-light leading-relaxed" data-id="element-675" data-mp="17sa16z5jo09j">
              Nisa is now open to all instructional coaches.
            </p>
          </div>

          {/* Main Content Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 mb-16" data-id="element-676" data-mp="yrlms3c8nxw4">
            {/* Left Column: Thank You Message */}
            <div className="bg-white/80 backdrop-blur-sm rounded-2xl p-8 md:p-10 shadow-sm border border-gray-100 flex flex-col justify-center h-full" data-id="element-677" data-mp="1rg0xwes91w26">
              <h2 className="text-2xl font-serif text-gray-900 mb-6" data-id="element-678" data-mp="1mi8zd1x3nbp0">
                To our pilot cohort
              </h2>
              <div className="space-y-6 text-lg text-gray-700 leading-relaxed" data-id="element-679" data-mp="1ho4mk215k9g0">
                <p data-id="element-680" data-mp="1cql9h5g6y2pn">
                  Thank you to all the coaches who participated in our pilot
                  program. Your insights, feedback, and dedication have been
                  instrumental in shaping Nisa.
                </p>
                <p data-id="element-681" data-mp="2cr6lr99i4655">
                  Because of your contributions, we've built a tool that truly
                  understands the nuances of instructional coaching—making it
                  more intentional, less administrative, and deeply impactful.
                </p>
                <div className="pt-4 flex items-center text-primary-700 font-medium" data-id="element-682" data-mp="2mr7a59m89cg7">
                  <Users className="w-5 h-5 mr-3" data-id="element-683" data-mp="2rpikrmkcjqzh" />
                  <span data-id="element-684" data-mp="2vqc3m1ixmfli">Built with coaches, for coaches</span>
                </div>
              </div>
            </div>

            {/* Right Column: Benefits/Features */}
            <div className="bg-gradient-to-br from-white/90 to-cyan-50/50 backdrop-blur-sm rounded-2xl p-8 md:p-10 shadow-sm border border-gray-100" data-id="element-685" data-mp="35flz7rcziged">
              <h2 className="text-2xl font-serif text-gray-900 mb-8" data-id="element-686" data-mp="3addqqk9pw0i1">
                Why join Nisa today?
              </h2>
              <ul className="space-y-6" data-id="element-687" data-mp="3fbozeroa04yo">
                <li className="flex items-start" data-id="element-688" data-mp="3jevdumljl2g8">
                  <div className="flex-shrink-0 mt-1" data-id="element-689" data-mp="3jfmy519ovdr7">
                    <div className="w-8 h-8 rounded-full bg-cyan-100 flex items-center justify-center" data-id="element-690" data-mp="ky2ggn846os2">
                      <Brain className="w-4 h-4 text-cyan-700" data-id="element-691" data-mp="g0kdddgs33rz" />
                    </div>
                  </div>
                  <div className="ml-4" data-id="element-692" data-mp="tpw0ijmuqhme">
                    <h3 className="text-lg font-medium text-gray-900" data-id="element-693" data-mp="tt0ajxn007kz">
                      Intelligent Support
                    </h3>
                    <p className="text-gray-600 mt-1" data-id="element-694" data-mp="1z81pe8nhobw">
                      AI tools that lighten your administrative workload so you
                      can focus on people, not paperwork.
                    </p>
                  </div>
                </li>
                <li className="flex items-start" data-id="element-695" data-mp="ayblyljk09rz">
                  <div className="flex-shrink-0 mt-1" data-id="element-696" data-mp="60jrbjriy9k3">
                    <div className="w-8 h-8 rounded-full bg-purple-100 flex items-center justify-center" data-id="element-697" data-mp="1mfusamsfksur">
                      <Users className="w-4 h-4 text-purple-700" data-id="element-698" data-mp="1hh0cltprfkev" />
                    </div>
                  </div>
                  <div className="ml-4" data-id="element-699" data-mp="1px90rcmx4g6k">
                    <h3 className="text-lg font-medium text-gray-900" data-id="element-700" data-mp="1pwh6q68yyqie">
                      Deeper Relationships
                    </h3>
                    <p className="text-gray-600 mt-1" data-id="element-701" data-mp="1fzun1ksdq5hy">
                      Tools designed to strengthen the coach-teacher partnership
                      through consistent, high-quality support.
                    </p>
                  </div>
                </li>
                <li className="flex items-start" data-id="element-702" data-mp="28p1tr71zm1ea">
                  <div className="flex-shrink-0 mt-1" data-id="element-703" data-mp="2dnmmklewtisp">
                    <div className="w-8 h-8 rounded-full bg-teal-100 flex items-center justify-center" data-id="element-704" data-mp="2dpfxwe0gwr71">
                      <CheckCircle className="w-4 h-4 text-teal-700" data-id="element-705" data-mp="1ywmdqfa93mw1" />
                    </div>
                  </div>
                  <div className="ml-4" data-id="element-706" data-mp="2rne611o73re3">
                    <h3 className="text-lg font-medium text-gray-900" data-id="element-707" data-mp="2rmcl85hdnqj6">
                      Immediate Access
                    </h3>
                    <p className="text-gray-600 mt-1" data-id="element-708" data-mp="2wfnued9nwje9">
                      No waitlists. Create your account and start using Nisa
                      with your teachers today.
                    </p>
                  </div>
                </li>
              </ul>
            </div>
          </div>

          {/* CTA Section */}
          <div className="bg-primary-900 rounded-2xl p-8 md:p-12 shadow-xl text-center relative overflow-hidden" data-id="element-709" data-mp="2salai6ek5v2o">
            {/* Decorative background elements for CTA */}
            <div className="absolute top-0 right-0 w-64 h-64 bg-white/5 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2" data-id="element-710" data-mp="2ncs9drs43r99" />
            <div className="absolute bottom-0 left-0 w-64 h-64 bg-cyan-400/10 rounded-full blur-3xl translate-y-1/2 -translate-x-1/2" data-id="element-711" data-mp="2dkmd45utuno9" />

            <div className="relative z-10 max-w-3xl mx-auto" data-id="element-712" data-mp="28nnog2txn8xg">
              <h2 className="text-3xl md:text-4xl font-serif text-white mb-6" data-id="element-713" data-mp="24kqzludsugl2">
                Ready to transform your coaching practice?
              </h2>
              <p className="text-lg text-cyan-100 mb-8 max-w-2xl mx-auto" data-id="element-714" data-mp="1znhaygy8i8ya">
                Join the community of instructional coaches using Nisa to make
                their day-to-day work more impactful.
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-715" data-mp="o4a499hei024">
                <a href="http://app.nisa.coach" data-id="element-716" data-mp="t34yr8oqdd22">
                  <Button size="lg" className="bg-white text-primary-900 hover:bg-cyan-50 border-transparent w-full sm:w-auto" data-id="element-717" data-mp="t2lcxgvym4ir">
                    Create a coach account
                    <ArrowRight className="w-5 h-5 ml-2" data-id="element-718" data-mp="do8agko868h" />
                  </Button>
                </a>
                <a href="https://app.nisa.coach/" data-id="element-719" data-mp="5dangvk27wjx">
                  <Button variant="outline" size="lg" className="border-cyan-700 text-cyan-100 hover:bg-primary-800 hover:text-white hover:border-cyan-500 w-full sm:w-auto" data-id="element-720" data-mp="5bpp0uumjtgs">
                    Log in to existing account
                  </Button>
                </a>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer data-id="element-721" data-mp="2758exhl4x0rz" />
    </div>;
};